/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { selectLogin } from '../../../../store/login/loginSlice';
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { CustomGrid, CustomInfosForm } from '../../../../assets/style/globalStyle';
import { Stack, Typography, Button, Card, Grid, DialogActions, Box } from '@mui/material';
import { isMobile } from 'react-device-detect';

import configAxios from '../../../../services/configAxios';
import RenderPage from '../../../layouts/RenderPage';
import Iconify from '../../../../@core/theme/Iconify';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';
import palette from 'src/@core/theme/palette';
import MoreMenu from '../../../components/multiplesComponents/MoreMenu';

import DataGrid, {
  Scrolling,
  Paging,
  HeaderFilter,
  Pager,
  SearchPanel,
  GroupPanel,
  Column,
  ColumnChooser,
  ColumnFixing,
  Selection
} from 'devextreme-react/data-grid';

const allowedPageSizes = [5, 10, 20, 30];

const checkIn = (props) => {
  const [infosCheckIn, setInfosCheckIn] = useState([]);
  const [rowsSelected, setRowsSelected] = useState([]);

  const infoStateTemp = useSelector(selectLogin);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });

  useEffect(() => {
    getCheckIn();
  }, []);

  async function getCheckIn() {
    configAxios
      .get(`/establishments/listTokenToEstablishment/${infoState.id_establishment}`)
      .then((response) => {
        setInfosCheckIn(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para carregar os check-ins! Tente novamente!',
          'Atenção'
        );
      });
  }

  function selectedRows(event) {
    setRowsSelected(event.selectedRowsData[0]);
  }

  function HandleSubmit() {
    if (rowsSelected.length !== 0) {
      const infos = {
        token: rowsSelected.token_id,
        idEstablishment: rowsSelected.id_establishment
      };
      configAxios
        .post('/establishments/validateTokenToEstablishment', infos)
        .then((response) => {
          if (response.status === 202) {
            NotificationManager.warning(
              'O Parceiro não atende o plano do beneficiário informado no token!',
              'Atenção'
            );
          } else if (response.status === 201) {
            NotificationManager.warning(
              'Token não localizado, ou já utilizado, por favor confirme com o usuário!',
              'Atenção'
            );
          } else if (response.status === 200) {
            NotificationManager.success(
              'Token validado com sucesso, por favor libere a entrada do usuário!',
              'Sucesso'
            );
            getCheckIn();
          }
          setRowsSelected([]);
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades para validar o token, tente novamente mais tarde!',
            'Atenção'
          );
        });
    } else {
      NotificationManager.error(
        'Nenhuma linha foi selecionada, por favor, selecione o check-in primeiro e tente novamente!',
        'Atenção'
      );
    }
  }

  return (
    <RenderPage title="CheckIn">
      <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
        <Grid container>
          <BreadcrumbsNav {...props} />
          <Grid item xs={12} sx={{ mt: 2 }}>
            <Typography variant="h4" gutterBottom>
              Check-ins do Dia
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" gutterBottom>
              Utilize as opções abaixo para filtrar e visualizar os check-in disponíveis hoje
            </Typography>
          </Grid>
        </Grid>
        <Stack direction="row" alignItems="center" justifyContent="end" mb={2}>
          {!isMobile && (
            <>
              <Button
                variant="outlined"
                color="error"
                component={RouterLink}
                to="/app/dashboard"
                startIcon={<Iconify icon="eva:arrow-back-fill" />}>
                Voltar
              </Button>
            </>
          )}
        </Stack>
      </Stack>
      <Card>
        {/* <form onSubmit={HandleSubmit}> */}
        <CustomGrid>
          <DataGrid
            dataSource={infosCheckIn}
            showBorders={true}
            remoteOperations={true}
            wordWrapEnabled={true}
            allowColumnResizing={true}
            columnAutoWidth={true}
            onSelectionChanged={selectedRows}
            noDataText={'Não foram encontrados registros'}>
            <Selection mode="single" />
            <Column dataField="nome_usuario" />
            <Column dataField="codigo_plano" caption="Plano" />
            <Column dataField="token_id" caption="Token" />
            <Column dataField="status" caption="Status" />
            <SearchPanel visible={true} width={240} placeholder="Procurar..." />
            {!isMobile && (
              <GroupPanel visible={true} emptyPanelText="Arraste as colunas aqui para agrupar" />
            )}
            <Scrolling rowRenderingMode="virtual"></Scrolling>
            <Paging defaultPageSize={5} />
            <Pager
              visible={true}
              allowedPageSizes={allowedPageSizes}
              showPageSizeSelector={true}
              showInfo={true}
              showNavigationButtons={true}
            />
            <ColumnChooser
              enabled={true}
              title={'Escolher uma coluna'}
              emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
            />
            <ColumnFixing enabled={true} />
            <HeaderFilter visible={true} allowSearch={true} />
          </DataGrid>
        </CustomGrid>
        <DialogActions>
          <Button
            onClick={HandleSubmit}
            type="submit"
            variant="contained"
            size="medium"
            color="success"
            startIcon={<Iconify icon="eva:checkmark-circle-2-fill" />}>
            Validar Check-in
          </Button>
          <Button
            style={{ marginLeft: 10 }}
            variant="contained"
            color="error"
            component={RouterLink}
            to="/app/Dashboard"
            startIcon={<Iconify icon="eva:close-circle-fill" />}>
            Cancelar
          </Button>
        </DialogActions>
        {/* </form> */}
      </Card>
    </RenderPage>
  );
};

export default checkIn;
